import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import MailEdit from "../../components/MailEdit";
import { format } from "date-fns";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem, Typography } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InputAdornment from '@mui/material/InputAdornment';
export default function CreatePost(){

    const [tanggalNotifikasi,setTanggalNotifikasi] =useState(new Date())
    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchPosts();
        console.log(posts)
    }, [skip,query]);

    async function newInquiry(e){
        history("/new-inquiry",{state:{stuff:"new"}})
    }
    const [editMailOpen,setEditMailOpen] = useState(false)
    const [useData,setUseData] =useState();
    function generateWhatsAppMessage(post, searchThis) {
        let message = '';
        const today = new Date();
        const formattedToday = `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
    
        if (post.tipe === 'Surat') {
            message += '*Document Notification Zanio*\n\n';
            message += `To: ${searchThis === 'Perusahaan' ? post.useData.company.namaPerusahaan : post.useData.klien.Nama}\n`;
            message += `From: ${post.dataSurat.pengirim ? post.dataSurat.pengirim : 'tidak ditulis'}\n`;
            message += `Doc: ${post.dataSurat.TipeDok}\n`;
            message += `Tanggal: ${formattedToday}\n\n`;
            message += `${post.dataSurat.nomorTandaTerima}`;
        } 
        else if (post.tipe === 'SharedCall') {
            message += '*Incoming Call Notification Zanio*\n';
            message += `${formattedToday}\n\n`;
            message += `Call To: ${searchThis === 'Perusahaan' ? post.useData.company.namaPerusahaan : post.useData.klien.Nama}\n`;
            message += `From: ${post.dataCall.penelpon ? post.dataCall.penelpon : 'tidak mau memberi tahu'}\n`;
            message += `Phone: ${post.dataCall.noTelpPenelpon ? post.dataCall.noTelpPenelpon : 'tidak mau memberi tahu'}\n`;
            message += `About: ${post.dataCall.noTelpPenelpon ? post.dataCall.noTelpPenelpon : 'tidak mau memberi tahu'}`;
        }
    
        return message;
    }

    async function editInquiry(post, searchThis){
    setEditMailOpen(true)
    setUseData(post)
    console.log(post)
    if(post.statNotify === "No"){
    
    const message = generateWhatsAppMessage(post, searchThis);
    let url = `https://wa.me/${post.useData.klien.Phone}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
}
}
    

    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis);
                    if(error){
                        
                        console.log(error.message);
                        return;
                    }
                    console.log(data)

                    if(data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }


                    const yoyo = data

                    //success
                    setPosts([...posts, ...yoyo])
                }catch(error){
                    console.log(error);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,query);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }

            console.log(data)
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    const [fileURL, setFileURL] = useState("");


    const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const id = post._id
    
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/renderKontrakVOfromDB`,{
           id 
        }, {
            responseType: "blob"
          }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
                

            

        
        
        console.log("2")
    
    }

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value, searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            console.log(data)

            const yoyo = data
            //success
            setPosts([...yoyo])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)

                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }
    const ColorButton = styled(Button)(({ theme }) => ({
        color: theme.palette.getContrastText(purple[500]),
        backgroundColor: purple[500],
        '&:hover': {
          backgroundColor: purple[700],
        },
      }));

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }
    const [searchThis, setsearchThis]= useState("Perusahaan");
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/create-kontrak",{state:{data:post, stuff:"edit"}})
        }else{
            history("/create-kontrak",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const extend = async (post)=>{
        if(currPreview === "none"){
            history("/create-kontrak", {state:{data:post,stuff:"extend"}})
        }else{
            history("/create-kontrak", {state:{data:currPreview,stuff:"extend"}})
        }
    }

    const [openSignature,setOpenSignature] = useState(false);
    const closeeditMailOpen = () => {
        setEditMailOpen(false)
    }

    const openSignatureNow = () => {
        setOpenSignature(true)

    }
    const [error,setError]=useState()
    const [sudah,setSudah] = useState()
    const simpanNotifikasi = () => {
        if(sudah){
        if(sudah.trim()==="Sudah" || sudah.trim() === "sudah"){
            setError()
            axios.post(`${process.env.REACT_APP_BACKEND_URL}/updateNotifikasi`, {
                tanggalNotifikasi, id:useData._id
            }).then(() => {
                window.location.reload(); // refresh the page after successful update
            }).catch(error => {
                // handle error
                console.log(error);
            });
        }else{
            setError("Pastikan kamu ketik Sudah di tempat yang kosong")
        }
    }else{
        setError("Pastikan kamu ketik Sudah di tempat yang kosong")

    }
    }
    

    return <Grid container>
                <Dialog open={editMailOpen} onClose={closeeditMailOpen} maxWidth={"xl"}>
    <Grid sx={{p:2}}>
        <Grid 
        container 
        direction="column" 
        justifyContent="center" 
        alignItems="center" 
        spacing={2} // To add spacing between grid items
        >
            {useData?.statNotify === "No" ?        (
            <>
            <Grid item xs={12}>
                Sudah Kamu kirim WhatsApp nya?
            </Grid>
            <Grid item xs={12}>
                <TextField autoFocus placeholder="Ketik 'Sudah'" value={sudah} onChange={(event)=>setSudah(event.target.value)}></TextField>
            </Grid>
            <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDateFns}  style={{ marginRight: 'auto' }}>

                <MobileDatePicker 
                    views={['year', 'month', 'day']}
                    inputFormat="dd/MM/yyyy"
                    value={tanggalNotifikasi}
                    onChange={(event)=>setTanggalNotifikasi(event)}
                    renderInput={(params) => 
                        <TextField 
                            {...params} 
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment >
                                        <CalendarMonthIcon />
                                    </InputAdornment>
                                ),
                                style: { height: '35px'}
                            }}
                        />
                    }
                />

                </LocalizationProvider>
            </Grid>
            {error && <Grid className="error_text" sx={{mb:3}}>{error}</Grid>}
            <Grid item xs={12}>
                <Button onClick={closeeditMailOpen} variant="contained">
                <Typography>Belum</Typography>
                </Button>
            </Grid>
            <Grid item xs={12}>
                <Button onClick={simpanNotifikasi} variant="contained" color="success">
                <Typography>Sudah</Typography>
                </Button>
            </Grid>
            </>
        )
        :
        (
            <>
            <Grid item xs={12}>
                <Typography>Sudah dinotifikasi/diambil</Typography>
            </Grid>
            <Grid item xs={12}>
                <Button onClick={closeeditMailOpen} variant="contained" color="error">
                <Typography>Tutup</Typography>
                </Button>
            </Grid>
            </>
        )}
        </Grid>
    </Grid>
</Dialog>

                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid xl={10.8} lg={10.6} md={10.4} sm={8.8} >
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURL} width="100%" height="500" style={{zoom:"150%"}}/>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button variant="contained" color="error" style={{ marginRight: 'auto' }}>
                        Batal Kontrak
                    </Button>
                    <Button onClick={() => editPI()}>
                        <EditIcon></EditIcon>
                    </Button>
                    <ColorButton variant="contained" onClick={openSignatureNow}>Upload Tanda Tangan</ColorButton>
                    <Button onClick={() => extend()} variant="contained" color="success">
                        Extend
                    </Button>
                    </DialogActions>
                </Dialog>
                <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                <Header judul="Notifikasi" isi="Jangan lupa kirimkan notifikasi ini ke klien, hilangkan warna merah"></Header>
                    </Grid>
                    <Grid sx={{ mt:15}}></Grid>
                    <Grid sx={{ pl:15}}>
                        
                            <Grid container>
                                <Grid item xs={2}>
                            <Select  fullWidth value={searchThis} onChange={event => setsearchThis(event.target.value)}><MenuItem value="Perusahaan">Perusahaan</MenuItem><MenuItem value="Klien">Klien</MenuItem><MenuItem value="nomorTandaTerima">Tanda Terima</MenuItem></Select>
                        </Grid>
                                <TextField value={query} onChange={event => handleSearch(event)}></TextField>
                            </Grid>
                            <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 500, minHeight: 440 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Tanggal Kejadian
                                                </TableCell>
                                                <TableCell>
                                                    Perusahaan
                                                </TableCell>
                                                <TableCell>
                                                    Klien
                                                </TableCell>
                                               
                                                <TableCell>
                                                    Tipe Dokumen/Paket
                                                </TableCell>
                                                <TableCell>
                                                    Status
                                                </TableCell>
                                                
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover onClick={()=> editInquiry(post)}
                                                    sx={{ '&:hover': {
                backgroundColor: '#cceffb !important',
            },backgroundColor: post.statNotify === 'No' ? 'red' : 'white'}}>
                                                    <TableCell onClick={()=> editInquiry(post)} style={{cursor:'pointer'}}>
                                                        <p>{format(new Date(post.tanggalKejadian), 'dd MMM yyyy')}</p>                                                
                                                    </TableCell>

                                                    <TableCell onClick={()=> editInquiry(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.useData.company?.namaPerusahaan??""}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> editInquiry(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.useData.klien?.Nama??""}</p>
                                                    </TableCell>

                                                    <TableCell onClick={()=> editInquiry(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.dataSurat?.TipeDok?? ""}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> editInquiry(post)} style={{cursor:'pointer'}}>
                                                        <p>{post?.statNotify?? ""}</p>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))}

                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
            </Grid>
    };